import Table from "@/components/AdvanceTable"
import {getUserList,userAdd,userUpdate,userDelete} from "@/api/manager.js"
import {getAll} from "@/api/company"
import {getSearchParm} from "@/utils/index.js"
import {message} from 'ant-design-vue'
import Checkbutton from './checkcode.vue'

const columns = [
    {dataIndex:"id",key:"id",title:"序号",scopedSlots: { customRender: 'tindex' }},
    {dataIndex:"username",key:"username",title:"账号"},
    // {dataIndex:"password",key:"password",title:"密码"},
    {dataIndex:"roleName",key:"roleName",title:"角色"},
    {dataIndex:"cmpid",key:"cmpid",title:"公司",myRender:"company",scopedSlots: { customRender: 'company' }},
    {key:"action",title:"操作",scopedSlots: { customRender: 'action' }},
]

export default {
    data(){
		let user = JSON.parse(sessionStorage.getItem("userinfo"))
        return {
            columns,
            request:{
                "get":(parm)=>{
					if(user.cmpid == -1){
						return getUserList(parm)
					}else{
						return getUserList({...parm,"cmpid":user.cmpid})
					}
				} ,
                "add":userAdd,
                "update":userUpdate,
                "delet":userDelete
            },
            searchData:getSearchParm({
                username:"",
				cmpid:""
            }),
			user,
			cmps:[],
			formData:{
				username:"",
				password:"",
				role:"",
				roleName:"",
				cmpid:''
			},
			updateid:0,//0添加 1修改
		}
    },
    components:{
        Table,
		Checkbutton
    },
    beforeRouteEnter(to,from,next){
        let user = sessionStorage.getItem("userinfo")
        user = JSON.parse(user)
        if(user&&(user.role=="admin" ||user.cmpid == -1)){
            next()
        }else{
            next({"name":'Login'})
        }
    },
    computed:{
    },
    mounted(){
		getAll().then(ret=>{
			if(ret.code == 0){
				let list = ret.ret
				if(this.user.cmpid == -1){
					this.cmps = list
				}else{
					let cmp = list.find(item=>{
						return item.id == this.user.cmpid
					})
					if(cmp){
						this.cmps = [cmp]
					}
				}
			}
		})
    },
    methods:{
        updateuser(record,showModal){
            this.formData = {...record,code:""}
			this.updateid = record.id
            showModal("修改管理员信息",[
                {"value":"username","text":"用户名",msg:true,checkfn:(text)=>{
					let reg = /^1[0-9]{10}$/
					console.log(reg.test(text),"aaaa")
					if(!reg.test(text)){
						message.error("请输入正确的手机号码")
						return false
					}
					return true;
				}},
                {"value":"password","text":"密码",msg:true,checkfn:(text)=>{
					let reg1 = /^[a-zA-Z0-9!@#$%^&*()-+'"]{6,14}$/,reg2 = /^[a-zA-Z]{6,14}$/,reg3=/^[0-9]{6,14}$/
					if(!reg1.test(text)){
						message.error("密码要求6-14位字母，数字，和其他字符",1)
						return false
					}
					if(reg2.test(text)){
						message.error("密码不能只包含字母",1)
						return false
					}
					if(reg3.test(text)){
						message.error("密码不能只包含数字",1)
						return false
					}
					return true
				}},
                {"value":"roleName","text":"角色"},
                {"value":"code","text":"验证码"},
                {"value":"cmpid","text":"公司"},
                ])
        },
        addUser(showModal){
            this.formData = {role:"admin"}
			this.updateid = 0
			if(this.user.cmpid != -1){
            	this.formData = {role:"admin",cmpid:this.user.cmpid}
			}
            showModal("添加管理员",[
                {"value":"username","text":"用户名",msg:true,checkfn:(text)=>{
					let reg = /^1[0-9]{10}$/
					if(!reg.test(text)){
						message.error("请输入正确的手机号码")
						return false
					}
					return true;
				}},
                {"value":"password","text":"密码",msg:true, checkfn:(text)=>{
					let reg1 = /^[a-zA-Z0-9!@#$%^&*()-+'"]{6,14}$/,reg2 = /^[a-zA-Z]{6,14}$/,reg3=/^[0-9]{6,14}$/
					if(!reg1.test(text)){
						message.error("密码要求6-14位字母，数字，和其他字符",1)
						return false
					}
					if(reg2.test(text)){
						message.error("密码不能只包含字母",1)
						return false
					}
					if(reg3.test(text)){
						message.error("密码不能只包含数字",1)
						return false
					}
					return true
				} },
                {"value":"roleName","text":"角色"},
                {"value":"cmpid","text":"公司"},
                ])
        },
        deleteUser(record,showDelConfirm){
            this.formData = {...record}
            showDelConfirm()
        },
		getcmpname(id){
			let tmp = this.cmps.find(item=>item.id==id)
			if(tmp){
				return tmp.name
			}else{
				return ""
			}
		}
    }
}